import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { FormControl, Grid, InputLabel } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { reformatDateYYYYmmDD, validateRut } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import { TEXT_COLOR_FT } from 'config/config';

const EditableRow = ({ row, headCells, isEditing, isEditable, onInputChange, onSave, onEdit,
    onDelete, profesiones
}) => {

    const optionsReturn = (arr) => {
        return arr.map((item, index) => {
            return <MenuItem key={index} value={item.id}> {item.profesion}</MenuItem>
        })
    }

    const dateData = (data) => {

        return reformatDateYYYYmmDD(data)

    }

    const validateEmptyField = (str) => {
        if (str) {
            return true
        } else {
            return false
        }
    }

    const validateMail = (mail) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(mail)
    }

    const validateForm = () => {

        const fieldsToValidate = headCells.filter(field => {

            if (field.id === 'rut') {
                return !validateRut(row[field.id])
            } else if (field.id === 'correo') {
                return !validateMail(row[field.id])
            } else if (field.id === 'telefono') {
                if (row[field.id] === '' || row[field.id] === undefined) {
                    return true
                } else {
                    return false
                }

            } else {
                return row[field.id] === ''
            }
            //return true;
        });

        return !fieldsToValidate.every(field => headCells[field] === true);

    }

    const renderCellContent = (headCell) => {
        if (isEditing) {
            switch (headCell.type) {

                case 'text':
                    return (
                        <TextField
                            error={row[headCell.id] === ''}
                            size='small'
                            variant='outlined'
                            value={row[headCell.id] || ''}
                            onChange={(e) => onInputChange(e, headCell.id)}

                        />
                    );
                case 'rut':
                    return (
                        <TextField
                            error={
                                !validateRut(row[headCell.id])
                            }
                            size='small'
                            variant='outlined'
                            value={row[headCell.id] || ''}
                            onChange={(e) => onInputChange(e, headCell.id, headCell.type)}

                        />
                    );
                case 'phone':
                    return (
                        <TextField
                            error={!validateEmptyField(row[headCell.id])}
                            size='small'
                            variant='outlined'
                            value={row[headCell.id] || ''}
                            onChange={(e) => onInputChange(e, headCell.id, headCell.type)}

                        />
                    );
                case 'mail':
                    return (
                        <TextField
                            error={!validateMail(row[headCell.id])}
                            size='small'
                            variant='outlined'
                            value={row[headCell.id] || ''}
                            onChange={(e) => onInputChange(e, headCell.id, headCell.type)}

                        />
                    );
                case 'number':
                    return (
                        <TextField
                            error={!validateEmptyField(row[headCell.id])}
                            size='small'
                            variant='outlined'
                            value={row[headCell.id] || ''}
                            onChange={(e) => {

                                if (/^\d*$/.test(e.target.value)) {
                                    onInputChange(e, headCell.id)
                                }
                            }
                            }

                        />
                    );
                case 'select':
                    return (
                        <FormControl size='small' fullWidth>
                            <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                {row[headCell.label] || ''}
                            </InputLabel>
                            <Select
                                variant='outlined'
                                value={row[headCell.id] || ''}
                                onChange={(e) => onInputChange(e, headCell.id)}
                            >
                                {optionsReturn(profesiones)}
                            </Select>
                        </FormControl>
                    );
                case 'date':
                    return (
                        <TextField
                            error={!validateEmptyField(row[headCell.id])}
                            size='small'
                            type="date"
                            variant='outlined'
                            value={dateData(row[headCell.id]) || ''}
                            onChange={(e) => onInputChange(e, headCell.id)}
                        />
                    );
                default:
                    return row[headCell.id];
            }
        }
        if (headCell.id === 'profesion') {
            let aux = profesiones.find(e => e.id === parseInt(row[headCell.id]))
            if(aux){
                return aux.profesion
            }else{
                return ''
            }
            
        } else {
            return row[headCell.id];
        }

    };

    return (
        <TableRow>
            {headCells.map((headCell) => {
                if(headCell.shown){
                    return (
                <TableCell key={headCell.id} align={headCell.align || 'left'} 
                style={{ color: TEXT_COLOR_FT, paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 10 }}
                >
                    {renderCellContent(headCell)}
                </TableCell>
            )
                } else{
                    return null
                }
            })}
            <TableCell align="center" style={{ color: TEXT_COLOR_FT, paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 10 }}>
                {isEditing ? (<Grid container style={{ flexWrap: 'nowrap' }}>
                    <IconButton onClick={onSave} style={{ color: validateForm() ? 'gray' : 'green' }} disabled={validateForm()}>
                        <SaveIcon />
                    </IconButton>
                    <IconButton onClick={onDelete} style={{ color: 'red' }}>
                        <Delete />
                    </IconButton>
                </Grid>

                ) : (
                    <Grid container style={{ flexWrap: 'nowrap' }}>
                        <IconButton onClick={onEdit} disabled={!isEditable} style={{ color: !isEditable ? 'gray' : 'green' }}>
                            <EditIcon />
                        </IconButton>
                        <IconButton onClick={onDelete} style={{ color: 'red' }}>
                            <Delete />
                        </IconButton>
                    </Grid>

                )}
            </TableCell>
        </TableRow>
    );
};

EditableRow.propTypes = {
    row: PropTypes.object.isRequired,
    headCells: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
        })
    ).isRequired,
    isEditing: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
};

export default EditableRow;
